// Library methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DefaultModal from "../DefaultModal/DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
  ModalCustomDeleteSolid,
} from "src/styles/mui/muiStylesHelper";

type SharedModalType = {
  open: boolean;
  title: string;
  modalDescription: string | JSX.Element;
  confirmButtonText: string;
  confirmButtonVariant?: "default" | "error";
  isDisabledButton?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const SharedModal = ({
  open,
  title,
  modalDescription,
  confirmButtonText,
  confirmButtonVariant = "default",
  isDisabledButton = false,
  onClose,
  onConfirm,
}: SharedModalType) => {
  const { t } = useTranslation();

  const confirmButtonColor = useMemo(() => {
    if (confirmButtonVariant === "error") {
      return ModalCustomDeleteSolid;
    }

    // default
    return ModalCustomConfirm;
  }, [confirmButtonVariant]);

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={title}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
          }}
        >
          <Button sx={ModalCustomCancel} onClick={onClose}>
            {t("Cancel")}
          </Button>
          <Button
            sx={confirmButtonColor}
            onClick={onConfirm}
            disabled={isDisabledButton}
          >
            {confirmButtonText}
          </Button>
        </Grid>
      }
    >
      <Grid p="16px" display="flex" flexDirection="column" gap="20px">
        <Typography fontSize="14px" component="div">
          {modalDescription}
        </Typography>
      </Grid>
    </DefaultModal>
  );
};

export default SharedModal;
